var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorklistStatusNotConnected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17144_32263)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_17144_32263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.23503 14.9017C11.9169 14.9017 14.9017 11.9169 14.9017 8.23503C14.9017 4.55313 11.9169 1.56836 8.23503 1.56836C4.55313 1.56836 1.56836 4.55313 1.56836 8.23503C1.56836 11.9169 4.55313 14.9017 8.23503 14.9017Z",
    fill: "#4E5D70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2351 6.23511L6.23511 10.2351M6.23511 6.23511L10.2351 10.2351M14.9017 8.23503C14.9017 11.9169 11.9169 14.9017 8.23503 14.9017C4.55313 14.9017 1.56836 11.9169 1.56836 8.23503C1.56836 4.55313 4.55313 1.56836 8.23503 1.56836C11.9169 1.56836 14.9017 4.55313 14.9017 8.23503Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17144_32263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.234375 0.234375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_17144_32263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.234375 0.234375)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorklistStatusNotConnected);
export default __webpack_public_path__ + "static/media/worklist-status-not-connected.e81da3bac78fe7cc699c5aed905f87e0.svg";
export { ForwardRef as ReactComponent };